export const account_type = [
	{ label: 'Savings', value: 'SAVINGS' },
	{ label: 'Current', value: 'CURRENT' },
];
